module.exports = __webpack_public_path__ + "static/media/recommendations.30fabf8d.svg";